// Module
var code = "<div class=\"three-dot-settings-container\"> <a class=\"pull-right three-dot-menu-container\"> <three-dots-option></three-dots-option> </a> </div> ";
// Exports
module.exports = code;